import * as React from 'react';

import { Header, Footer } from 'common/containers';
import { WrappedFC } from '../shared/types';

interface Props {
  /** ID。CSSの指定に使用されている */
  id?: string;
  /** スマホ表示か否か */
  isMobile?: boolean;
}

const DEFAULT_COMPONENT: keyof JSX.IntrinsicElements = 'div';

/**
 * レイアウトコンポーネント
 */
export const Layout: WrappedFC<typeof DEFAULT_COMPONENT, Props> = ({
  id = 'container',
  className = '',
  isMobile,
  'data-test': dataTest,
  element: Element = DEFAULT_COMPONENT,
  ...props
}) => {
  return (
    <Element {...props} id={id} className={className} data-test={dataTest}>
      <Header />
      {props.children}
      <Footer />
    </Element>
  );
};
Layout.displayName = 'Layout';
